module.exports = __webpack_public_path__ + "img/face-emoticon4.2057fbca.svg";